import React, { useState, useCallback } from "react";
import { AutocompleteInput, ReferenceInput } from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";
import PersonQuickCreateButton from "./PersonQuickCreateButton";

const useStyles = makeStyles({
  root: {
    display: "flex"
  }
});

const PersonReferenceInput = (props) => {
  const players = _.get(props, "players", []);
  const classes = useStyles();
  const [version, setVersion] = useState(0);
  const handleChange = useCallback(() => setVersion(version + 1), [version]);

  function teamName(choice) {
    //if( !choice.seasonTeamPlayers || choice.seasonTeamPlayers.length == 0 )
    return "";
    //return choice.seasonTeamPlayers[0].team.team.name + " " + choice.seasonTeamPlayers[0].team.seasonCode;
  }

  const optionRenderer = (choice) =>
    `${choice.name} (${teamName(choice)} ${choice.id})`;

  return (
    <div className={classes.root}>
      <div>
        <ReferenceInput
          key={version}
          label="Person"
          filterToQuery={(searchText) => ({ name: "%" + searchText + "%" })}
          reference="people"
          {...props}
        >
          <AutocompleteInput optionValue="id" optionText={optionRenderer} />
        </ReferenceInput>
      </div>

      <PersonQuickCreateButton onChange={handleChange} players={players} />
    </div>
  );
};

export default PersonReferenceInput;
